var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C7.40625 20.5 4.125 18.625 2.32812 15.5C0.53125 12.4141 0.53125 8.625 2.32812 5.5C4.125 2.41406 7.40625 0.5 11 0.5C14.5547 0.5 17.8359 2.41406 19.6328 5.5C21.4297 8.625 21.4297 12.4141 19.6328 15.5C17.8359 18.625 14.5547 20.5 11 20.5ZM15.4141 8.66406H15.375C15.7656 8.3125 15.7656 7.72656 15.375 7.33594C15.0234 6.98438 14.4375 6.98438 14.0859 7.33594L9.75 11.7109L7.91406 9.875C7.52344 9.48438 6.9375 9.48438 6.58594 9.875C6.19531 10.2266 6.19531 10.8125 6.58594 11.1641L9.08594 13.6641C9.4375 14.0547 10.0234 14.0547 10.4141 13.6641L15.4141 8.66406Z",
    fill: "#3E9728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b817ee4dd7721f831478359398017cf7.svg";
export { ForwardRef as ReactComponent };